import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import AmFeDropdownMenuMixin from './mixin';
let AmFeDropdownMenuForEdit = class AmFeDropdownMenuForEdit extends Mixins(AmFeDropdownMenuMixin) {
  constructor() {
    super(...arguments);
    this.editPanelIsShowing = false;
  }
  get editIconClass() {
    return this.editPanelIsShowing && this.isCustom ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down';
  }
  showEditPanel() {
    this.editPanelIsShowing = true;
  }
  hideEditPanel() {
    this.editPanelIsShowing = false;
  }
};
AmFeDropdownMenuForEdit.componentName = 'AmFeDropdownMenuForEdit';
AmFeDropdownMenuForEdit = __decorate([Component({
  name: 'AmFeDropdownMenuForEdit'
})], AmFeDropdownMenuForEdit);
export default AmFeDropdownMenuForEdit;